import styled from 'styled-components'

const MyDiv = styled.div`
.table_header th {
  position: sticky;
  top: 0;
  background: #fff;   
  z-index: 1;          
}

.flex_header{
    align-items: center;
    justify-content: space-between;
}
`
export default MyDiv
